import { Box, Container } from '@mui/material';
import { useState, useEffect } from 'react';
import ListCard from './list-card';
import ListFilters from './list-filters';
import { useJobsData } from 'src/context/job-context';
import { useAuthContext } from 'src/auth/hooks';

export default function ListPageView() {
  const { JobsData ,myJob} = useJobsData();
  const [sortOrder, setSortOrder] = useState('Acceding'); // default: ascending

  // Function to handle sorting based on the selected option
  const sortedJobs = JobsData.jobs.sort((a, b) => {
    const dateA = new Date(a.installationDate); // Ensure the date is in a comparable format
    const dateB = new Date(b.installationDate);

    if (sortOrder === 'Date Acceding') {
      return dateA - dateB; // Ascending order (earliest first)
    } else {
      return dateB - dateA; // Descending order (latest first)
    }
  });

  const { user } = useAuthContext();

  return (
    <Container maxWidth="lg">
      <ListFilters setSortOrder={setSortOrder} sortOrder={sortOrder} />
      <Box
        sx={{ paddingTop: '20px' }}
        gap={3}
        display="grid"
        gridTemplateColumns={{
          md: 'repeat(1, 1fr)',
          lg: 'repeat(1, 1fr)',
        }}
      >
        {sortedJobs.length > 0
          ? sortedJobs.map((item) =>
              myJob && item?.salesRepId == user?._id ? (
                <ListCard key={item.id} item={item} />
              ) : !myJob ? (
                <ListCard key={item.id} item={item} />
              ) : null
            )
          : null}
      </Box>
    </Container>
  );
}
